<template>
    <div class="post---flight--reporting-main">

        <div class="box">


            <div class="box">
                <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>PIC Sign</p></div>
                <div>
                    <textarea class="textarea" name="" cols="165" rows="5" readonly>I hereby certify that the data I have filled out is true.</textarea>
                </div>
                <div v-if="signatureShow">
                    <img :src="getSvgSignature" @error="errorsignature(0)" @load="errorsignature(1)" onerror="this.style.display='none'" width="300px" height="200px" alt="Signature">
                </div>
                <div v-if="!signatureShow">
                    <p>Signature couldn't get.</p>
                </div>
            </div>

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">PIC Sign</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input is-danger" type="text" v-if="InputsObject.AL.pic" v-model="InputsObject.AL.pic" disabled>
                        </div>
                    </div>
                </div>
            </div>

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Password</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input is-danger" type="text" disabled>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


    import {loadingMixin} from "../../../utils/mixins";
    import {/*mapActions,*/ mapState} from "vuex";
    import {createUrl} from "../../../http";
    export default {
        name: "PostValidateAndSign",
        props: ["id", "flight"],

        mixins: [loadingMixin],

        data() {
            return {
                // fueldata :"",
                // plannedfuelusage : 0,
                // captains : [],
                // diversionStat : false,
                Jpegshow : true,
                // datalogShow : true,
                // additionalInfo1Show : true,
                // additionalInfo2Show : true,
                signatureShow : true,
                // activeJpegUrl : createUrl('/EffIpadPreview/GetInputJpeg/'),
                activeSvgUrl : createUrl('/EffIpadPreview/GetInputSVG/'),
                // getJpegDatalog : "",
                // getJpegAdditionalInfo1 : "",
                // getJpegAdditionalInfo2 : "",
                getSvgSignature:"",
            }
        },

        computed : {
            ...mapState("ipadmain",[ "selectedFlightItems","EFF_Json_Data","WR_Json_Data","AttachmentsJson","OCCSelfVersions_VS_IPADLastKnownVersions","LastInputsJson","InputsObject"]),

            // PlannedFuelUsage : function ()
            // {
            //     return this.EFF_Json_Data.poFuel.TaxiFuelEstimatedWeightKg + this.EFF_Json_Data.poFuel.TripFuelEstimatedWeightKg ;
            // },
        },

        components: {

        },

        async created()
        {
            // this.getJpegDatalog = this.activeJpegUrl + this.id + "/" + this.flight.std + "/" + "AL_Datalog.jpg";
            // this.getJpegAdditionalInfo1 = this.activeJpegUrl + this.id + "/" + this.flight.std + "/" + "AL_AdditionalInfo1.jpg";
            // this.getJpegAdditionalInfo2 = this.activeJpegUrl + this.id + "/" + this.flight.std + "/" + "AL_AdditionalInfo2.jpg";
            this.getSvgSignature = this.activeSvgUrl + this.id + "/" + this.flight.std+ "/" + "AL_Signature.svg"+"/"+this.flight.flightArchiveStat;

            // this.GetCaptains();
        },

        methods: {

            // errorAdditionalInfo1(stat)
            // {
            //     if(stat == 0)
            //     {
            //         this.additionalInfo1Show = false;
            //     }
            //     else if(stat ==1)
            //     {
            //         this.additionalInfo1Show = true;
            //     }
            // },
            //
            // errorAdditionalInfo2(stat)
            // {
            //     if(stat == 0)
            //     {
            //         this.additionalInfo2Show = false;
            //     }
            //     else if(stat ==1)
            //     {
            //         this.additionalInfo2Show = true;
            //     }
            // },
            //
            // errordatalog(stat)
            // {
            //     if(stat == 0)
            //     {
            //         this.datalogShow = false;
            //     }
            //     else if(stat ==1)
            //     {
            //         this.datalogShow = true;
            //     }
            // },

            errorsignature(stat)
            {
                if(stat == 0)
                {
                    this.signatureShow = false;
                }
                else if(stat ==1)
                {
                    this.signatureShow = true;
                }
            },


            // GetCaptains()
            // {
            //
            //     this.captains.push(this.flight.cP1);
            //     this.captains.push(this.flight.cP2);
            //     this.captains.push(this.flight.cP3);
            //
            // },

            // async saveForm() {
            //     this.showLoading();
            //     try {
            //         await setTimeout(3000);
            //     } finally {
            //         this.hideLoading();
            //         this.$notify({title: "Success", type: "success", text: "Successfully"})
            //     }
            // },

        }
    }
</script>

<style scoped>
    .textarea{
        margin-top: 15px;
    }
</style>
